module.exports = __webpack_public_path__ + "static/img/01.dbf0b36.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/01.png
// module id = Qhem
// module chunks = 1